import React from "react";

const RouteFallback = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "240px" }}
      role="status"
      aria-live="polite"
    >
      <div className="spinner-border text-primary">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default RouteFallback;
